module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-top-panel-4-f1bc3b28ce965d22bd728933fb26a9a5.svg";